import { render, staticRenderFns } from "./main-navbar-update-info.vue?vue&type=template&id=4b102f38"
import script from "./main-navbar-update-info.vue?vue&type=script&lang=js"
export * from "./main-navbar-update-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports